// Campus photo for /colleges/new-jersey-institute-of-technology: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AEberhardt_Hall_-_NJIT_(55184171390).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/new-jersey-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "new-jersey-institute-of-technology",
    "alt": "Eberhardt Hall on its lawn above the street at NJIT in Newark, New Jersey",
    "src": "/colleges/new-jersey-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/new-jersey-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/new-jersey-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/new-jersey-institute-of-technology/og.jpg",
    "title": "Eberhardt Hall - NJIT (55184171390)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AEberhardt_Hall_-_NJIT_(55184171390).jpg",
    "read": "2026-10-02"
};

export default photo;
